import * as yup from "yup";
import { WeightUnit } from "__generated__/gql/graphql";
import { definedDecimalStr } from "utils/schemas/decimalStr";
import { formatCurrency, makeFormatDecimal } from "utils/formatting";
import { getNullableEnumSchema } from "utils/schemas/utils";
import tiHiSchema from "utils/schemas/tiHi";

export const productLineId = yup
  .string()
  .uuid()
  .label("Product Line")
  .required();

export const name = yup
  .string()
  .trim()
  .label("SKU Name")
  .required()
  .min(2)
  .max(100);

export const shortName = yup
  .string()
  .trim()
  .label("SKU Name (Short)")
  .max(35)
  .default(null)
  .nullable();

export const internalSkuId = yup
  .string()
  .label("Internal SKU Identifier")
  .trim()
  .nullable()
  .defined()
  .default(null)
  .max(100);

export const unitNetWeight = definedDecimalStr()
  .min(0)
  .max(1000, { isExclusive: true })
  .label("Unit Net Weight");

export const unitNetWeightUnit = getNullableEnumSchema<WeightUnit>(WeightUnit)
  .when("unitNetWeight", {
    is: (v: string) => !!v,
    then: (s) =>
      s.required("Unit is required when unit net weight is specified"),
  })
  .label("Unit");

const formatPounds = makeFormatDecimal({ style: "unit", unit: "pound" });

export const grossPalletWeightLbs = definedDecimalStr({
  numberFormatter: formatPounds,
})
  .min(0)
  .max(1e4, { isExclusive: true })
  .label("Gross Pallet Weight");

export const unitCogs = definedDecimalStr({ numberFormatter: formatCurrency })
  .min(0)
  .max(10000)
  .label("Unit COGS");

export const unitSrp = definedDecimalStr({ numberFormatter: formatCurrency })
  .min(0)
  .max(10000)
  .label("Unit SRP");

export const tiHi = tiHiSchema.label("Ti/Hi");
